export const GeneratingButton: React.FC = () => {
  return (
    <div
      className="w-fit px-4 py-1 text-xs select-none border border-white rounded text-black"
      style={{ animation: "rainbow 4s linear infinite" }}
    >
      Generating
    </div>
  );
};


